module.exports = __webpack_public_path__ + "img/yly_rm@2x.cbb5cc98.png";